(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ss-unidad-receptora', {
            parent: 'entity',
            url: '/ss-unidad-receptora',
            data: {
            	authorities: ['ROLE_ADMIN'],
                pageTitle: 'SSUnidadReceptoras'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-unidad-receptora/s-s-unidad-receptoras.html',
                    controller: 'SSUnidadReceptoraController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('ss-unidad-receptora-detail', {
            parent: 'ss-unidad-receptora',
            url: '/ss-unidad-receptora/{id}',
            data: {
            	authorities: ['ROLE_ADMIN'],
                pageTitle: 'SSUnidadReceptora'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-unidad-receptora/ss-unidad-receptora-detail.html',
                    controller: 'SSUnidadReceptoraDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'SSUnidadReceptora', function($stateParams, SSUnidadReceptora) {
                    return SSUnidadReceptora.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ss-unidad-receptora',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('ss-unidad-receptora-detail.edit', {
            parent: 'ss-unidad-receptora-detail',
            url: '/detail/edit',
            data: {
            	authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-unidad-receptora/ss-unidad-receptora-dialog.html',
                    controller: 'SSUnidadReceptoraDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SSUnidadReceptora', function(SSUnidadReceptora) {
                            return SSUnidadReceptora.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ss-unidad-receptora.new', {
            parent: 'ss-unidad-receptora',
            url: '/new',
            data: {
            	authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-unidad-receptora/ss-unidad-receptora-dialog.html',
                    controller: 'SSUnidadReceptoraDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                institucion: null,
                                institucionAbrev: null,
                                dependencia: null,
                                dependenciaAbrev: null,
                                unidadReceptora: null,
                                unidadReceptoraAbrev: null,
                                direccion: null,
                                email: null,
                                telefono1: null,
                                telefono2: null,
                                fax: null,
                                altaReg: null,
                                bajaReg: null,
                                ultActReg: null,
                                activo: null,
                                usuarioUltAct: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ss-unidad-receptora', null, { reload: 'ss-unidad-receptora' });
                }, function() {
                    $state.go('ss-unidad-receptora');
                });
            }]
        })
        .state('ss-unidad-receptora.edit', {
            parent: 'ss-unidad-receptora',
            url: '/{id}/edit',
            data: {
            	authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-unidad-receptora/ss-unidad-receptora-dialog.html',
                    controller: 'SSUnidadReceptoraDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SSUnidadReceptora', function(SSUnidadReceptora) {
                            return SSUnidadReceptora.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ss-unidad-receptora', null, { reload: 'ss-unidad-receptora' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ss-unidad-receptora.delete', {
            parent: 'ss-unidad-receptora',
            url: '/{id}/delete',
            data: {
            	authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-unidad-receptora/ss-unidad-receptora-delete-dialog.html',
                    controller: 'SSUnidadReceptoraDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SSUnidadReceptora', function(SSUnidadReceptora) {
                            return SSUnidadReceptora.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ss-unidad-receptora', null, { reload: 'ss-unidad-receptora' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
